module.exports = "/assets/6ecf1335f49c326fd404d85338015539.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/K5.png
// module id = 2657
// module chunks = 0